export class State {
    public files: Array<string> = new Array<string>();
}
